import styled from "styled-components";
import { FeatureTile } from "../molecules/FeatureTile";
import { FeatureTileGrid } from "./FeatureTileGrid";
import { PageSection } from "./PageSection";

const Wrapper = styled.section`
  display: grid;
  gap: 12px;
`;

export function HomeMenu() {
  return (
    <Wrapper>
      <PageSection>メニュー</PageSection>

      <FeatureTileGrid cols={2} gap={12}>
        <FeatureTile to="/scan" title="受付" description={"来場者の受付を行います"}></FeatureTile>
        <FeatureTile to="/list" title="来場者状況" description={"申込・来場状況を確認できます"}></FeatureTile>
      </FeatureTileGrid>
    </Wrapper>
  );
}
